import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_cross-green",
  "use": "icon_cross-green-usage",
  "viewBox": "0 0 24 23",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 23\" id=\"icon_cross-green\"><path d=\"M0 14.394h8.565v8.126h6.598v-8.126h8.482V8.126h-8.482V0H8.565v8.126H0v6.268z\" fill=\"#41C69B\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol